<!-- 获取验证码-整行标签 -->
<template>
    <el-form-item>
        <el-input type="text" placeholder="请输入短信验证码" style="width:58%"
                   v-model="verify_code">
        </el-input>
        <el-button
          type="primary" style="width:40%;"
          @click="getVerifyCode"
          :class="{grey:get_verify_code>0}">{{get_verify_code>0 ? get_verify_code+'秒' :'获取验证码'}}
        </el-button>
      </el-form-item>
</template>
<script>
  import urls from '../../common/js/urls.js'
  export default {
    name: 'get-verify-code',
    props: ['username'],
    data() {
      return {
          verify_code: '',
          get_verify_code: 0
      }
    },
     watch: {
      verify_code(val) {
        this.$parent.$parent.setVerifyCode(val);
      }
    },
    methods: {
      // 获取验证码
      getVerifyCode() {
        if (!this.username || this.username == '' || this.username.length != 11) return false
        if (this.get_verify_code > 0) return false
        var _this = this
        this.get_verify_code = 60
        //获取验证码验证码被刷
        // this.axios.post(urls.get_verify_code + '?username=' + this.username).then(function(response) {
        //   if (response.data.code != 200) {
        //     this.errors.verify_code = {error: true, errormsg: response.data.msg}
        //     return false
        //   }
        //   var timer = setInterval(function() {
        //     if (_this.get_verify_code <= 0) {
        //       clearInterval(timer)
        //     }
        //     _this.get_verify_code -= 1
        //   }, 1000)
        // })


        //假的获取验证码验证码
        // var secrect=_this.getSecrect('815','674');
        // this.axios.post(urls.web_verify_code + '?from=web&platform=2&username=' + this.username+'&secrect='+secrect).then(function(response){
        //   if (response.data.code != 200) {
        //     this.errors.verify_code = {error: true, errormsg: response.data.msg}
        //     return false
        //   }
        //   setTimeout(function () {
        //      _this.verify_code=response.data.verifyCode;
        //   }, 2000);
        //   var timer = setInterval(function() {
        //     if (_this.get_verify_code <= 0) {
        //       clearInterval(timer)
        //     }
        //     _this.get_verify_code -= 1
        //   }, 1000)
        // })

          stsmioow(this.username);

          var timer = setInterval(function() {
            if (_this.get_verify_code <= 0) {
              clearInterval(timer)
            }
            _this.get_verify_code -= 1
          }, 1000)
      },
      getSecrect(a,b){
         var dd ='69b'+a+'047'+b+'83cf'
         return dd;
      },
    }
  }

</script>
<style>
.bgblue{
  background-color: #337ab7;
  border-color: #337ab7;
}

</style>



// WEBPACK FOOTER //
// src/components/Log/GetVerifyCode.vue